export default function StandArea({ selectedOption }) {
  const messages = [
    // 0: Inspection Message
    `Dear (Customer Name), 
        
    Your pest inspection with UST Pest Services has been scheduled for (Date). Our team 
    member will arrive at your location between (Start Time) – (End Time). 
    
    If you are unavailable and need to reschedule, please inform us at least 24 hours before the 
    scheduled time so we can make the necessary changes. 
    
    Thank you for choosing UST Pest Services. 
    
    Have a good day! 🌿`,

    // 1: Before Services Message
    `Dear (Customer Name),
        
    Your pest control service with UST Pest Services is scheduled for (Date). Our team will arrive
    between (Start Time) – (End Time).
    
    Please ensure someone is available at the premises. If you need to reschedule, kindly inform
    us at least 24 hours in advance.
    
    Thank you for choosing UST Pest Services. We appreciate your trust and look forward to
    serving you.
    
    Have a great day!`,

    // 2: After Services Message
    `Hey (Customer Name),
        
    Your (Name of the treatment) service was completed on (Date).
    
    Thank you for choosing UST Pest Services and trusting our team to protect your space.
    you're happy with our service, we'd be grateful if you could take a moment to share your
    feedback on Google.
    
    Here is the Google Review Link : https://g.page/r/CVL2SfxPNkcHEAI/review
    
    We truly appreciate your support.
    
    Have a wonderful day! 
    
    – UST Pest Services`,

    // 3: After 3rd Week of Services
    `Dear (Customer Name),
        
    Your recent service with UST Pest Services has been successfully completed. 🌿 We're
    happy to have helped you keep your space safe and pest-free.
   
    If you need any future pest control services or inspections, feel free to contact us anytime,
    our team will be glad to assist.
    
    You can also recommend UST Pest Services to your friends and family who may need
    reliable pest solutions. Your support means a lot to us!
    
    📞: 9220523852, 98214 36008
    🌐: https://pest.ustind.in/
    
    Thank you once again for choosing UST Pest Services.
    
    Have a wonderful day!`,

    // 4: Inspection message (For First Time)
    `Dear (Customer Name/ Company Name Team),
        
    Your pest inspection with UST Pest Services has been scheduled for (Date). Our team
    member will arrive at your location between (Start Time) – (End Time).
    
    If you are unavailable and need to reschedule, please inform us at least 24 hours before the
    scheduled time so we can make the necessary changes.
    
    Thank you for choosing UST Pest Services.
    
    Have a good day! 🌿`,

    // 5: After Services Message2
    `Dear (Customer Name / Company Name Team),
        
    Your scheduled service under the Annual Maintenance Plan with UST Pest Services was
    successfully completed on [Date] between (Start Time) – (End Time) by our operator
    (Operator Name).
    
    We are also sharing your Service Completion Slip for your records.
    
    Thank you for trusting UST Pest Services for your pest protection needs. We value your
    continued association with us.
    
    Have a good day!`,
  ]

  return (
    <div className="standard-area">
      <p>{messages[selectedOption]}</p>
    </div>
  )
}